import { CloseOutlined } from "@ant-design/icons";
import { Button, Col, ConfigProvider, DatePicker, Form, Input, Modal, Row, Select } from "antd";

import viVN from 'antd/locale/vi_VN';

import { FormProps } from "antd/lib";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { editVehicleOwnership, InfoVehicleOwnership } from "../../../../../api/Customer_V2/customerApi_V2";
import { getListAllCustomerOption, getListCarColor, getSLCarsByCarLineIdAndCategoryCarId, getSLPurposeOfUse, getSLVehicleChassisNumbers } from "../../../../../api/selectOption/selectOptionsApi";
import { getListCodeCustomer, ICodeCustomer, ISelectOption } from "../../../../../api/selectOptions/selectOptionsApi";
import useDebounce from "../../../../../hook/useDebounce";
import useLoading from "../../../../../hook/useLoading";
import useThrottle from "../../../../../hook/useThrottle";
import useToast from "../../../../../hook/useToast";
import { dataVehicleStatus, VehicleStatusEnum } from "../../../../../services/data";
import { selectorCategoryCarIds } from "../../../../../store/slices/categoryCarSlice";
import { selectorInfoUser } from "../../../../../store/slices/infoUserSlice";
import { convertToAntdOptions, fommatSelectOption, fommatSelectOptionCustomerV2, fommatSelectOptionToUpperCase, getEditClass, handleStringToDayJsV4 } from "../../../../../until";
import '../../../styles.scss';

export const findNode = (data: any[], value: string): any | null => {
    for (const node of data) {
        if (node.value === value) return node;
        if (node.children) {
            const found = findNode(node.children, value);
            if (found) return found;
        }
    }
    return null;
};

const { TextArea } = Input;
interface ModalProps {
    isOpen: boolean
    idCustomer?: number
    infoVehicleOwnership?: InfoVehicleOwnership
    resultFormSubmit?: (iSsuccess: boolean, message?: string) => void
    closeModal: (isOpen: boolean) => void
}
const ModalUpdateVehicleInformation: React.FC<ModalProps> = ({
    isOpen, idCustomer, infoVehicleOwnership,
    resultFormSubmit, closeModal
}) => {
    const pushToast = useToast()
    const pushLoading = useLoading()
    const { id, username, unitTemp } = useSelector(selectorInfoUser)
    const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

    const prevSearchRef = useRef<string | undefined>(undefined);
    const scrollRef = useRef<HTMLDivElement | null>();
    const dropdownRef = React.useRef<HTMLDivElement | null>(null);

    const isProgrammaticCarLineSet = React.useRef(true);

    const [form] = Form.useForm();

    const [searchPurposeOfUse, setSearchPurposeOfUse] = useState<string>("");
    //

    const vehicleStatus = Form.useWatch("vehicleStatus", form); // ngày bắt đầu sở hữu

    const vehicleId = Form.useWatch("vehicleId", form); // tên xe
    const vehicleChassisNo = Form.useWatch("vehicleChassisNo", form); // số khung
    const oldOwnerDocDate = Form.useWatch("oldOwnerDocDate", form); // ngày bắt đầu sở hữu

    const [sLCarId, setSLCarId] = useState<any[]>([])
    const [sLChassisNo, setSLChassisNo] = useState<ISelectOption[]>([])
    const [cLCarColor, setCLCarColor] = useState<ISelectOption[]>([])
    const [sLPurposeOfUse, setSLPurposeOfUse] = useState<ISelectOption[]>([])
    const [pagination, setPagination] = useState({ current: 1, pageSize: 30, total: 0 });

    const [searchUser, setSearchUser] = useState<string>('')
    const [searchCar, setSearchCar] = useState<string>('')

    // const [listAllCustomerOption, setListAllCustomerOption] = useState<ISelectOption[]>([])


    const [sLCodeCustomer, setSLCodeCustomer] = useState<ICodeCustomer[]>([])

    const permission = infoVehicleOwnership?.permission




    // tên xe
    const gSLCarId = useDebounce(async () => {
        if (!idCustomer) return
        const result = await getSLCarsByCarLineIdAndCategoryCarId(
            idCustomer, undefined, undefined, searchCar
        )
        if (result?.status) {
            setSLCarId(convertToAntdOptions(result.data))
        }
    }, 1000)

    // số khuung
    const gSLChassisNo = async () => {
        if (!idCustomer) return
        if (!vehicleId) {
            setSLChassisNo([])
            return
        }
        const result = await getSLVehicleChassisNumbers(
            idCustomer, vehicleId,
        )
        if (result?.status) {
            setSLChassisNo(fommatSelectOptionToUpperCase(result.data))
        }
    }

    const gCLCarColor = async () => {
        const result = await getListCarColor()
        if (result?.status) {
            setCLCarColor(fommatSelectOption(result.data))
        }
    }

    const gSLPurposeOfUse = useDebounce(async () => {
        // if (!idCustomer) return
        const result = await getSLPurposeOfUse(
            searchPurposeOfUse
        )
        if (result?.status) {
            setSLPurposeOfUse(fommatSelectOption(result.data))
        }
    }, 1000)

    // ds chủ sở hữu xe
    // const gListAllCustomerOption = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {

    //     pushLoading(true)
    //     const result = await getListAllCustomerOption(pageSize, pageCurent, searchUser)
    //     if (result?.status) {
    //         setListAllCustomerOption(fommatSelectOptionCreator(result?.data))
    //         setPagination({ current: pageCurent, total: result.total, pageSize })
    //         // setPaginationTmp(pageCurent)
    //     } else {
    //         pushToast(result?.message, "warning")
    //     }
    //     pushLoading(false)
    // }, 1000)


    // const gListAllCustomerOption = useDebounce(async (current: number = 1) => {
    //     pushLoading(true)
    //     const result = await getListAllCustomerOption(
    //         30, current, searchUser, unitTemp,
    //         permittedCategoryCarIds
    //     );
    //     if (result?.status) {
    //         // Append nếu current > 1
    //         setListAllCustomerOption(prev =>
    //             current === 1 ?
    //                 fommatSelectOptionCustomerV2(result.data) :
    //                 [...prev, ...fommatSelectOptionCustomerV2(result.data)]
    //         );


    //         setPagination({ current, total: result.total, pageSize: 30 })
    //     }
    //     pushLoading(false)
    // }, 1000)


    const gSListCodeCustomer = useDebounce(async (current: number = 1) => {
        pushLoading(true)
        const result = await getListCodeCustomer(
            permittedCategoryCarIds,
            undefined, searchUser, undefined, undefined, 50, current, 1
        );
        if (result?.status) {
            // Append nếu current > 1
            setSLCodeCustomer(prev =>
                current === 1
                    ? result.data                // load lần đầu
                    : [...prev, ...result.data]  // append
            );

            setPagination(prev => ({
                ...prev,
                current,
                total: result.total || 0
            }));
        }
        pushLoading(false)
    }, 500)

    const onPopupScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const target = e.target as HTMLDivElement;

        const isBottom =
            target.scrollTop + target.offsetHeight >= target.scrollHeight - 20;

        if (!isBottom) return;

        const { current, total, pageSize } = pagination;

        const hasMore = sLCodeCustomer.length < total;
        if (!hasMore) return;

        const nextPage = current + 1;

        gSListCodeCustomer(nextPage);
    };

    const submitForm = () => {
        if (form) {
            form.submit();
        }
    };
    const onFinish: FormProps["onFinish"] = useThrottle(async (values: any) => {
        // console.log(values);

        if (!idCustomer || !infoVehicleOwnership?.id) return

        const {
            vehicleId, vehicleChassisNo, vehicleStatus, paperReason,
            customerName, oldVehiclePlateNumber, oldOwnerDocDate, ownershipEndDate,
            newOwnerCustomerId, newVehiclePlateNumber, newOwnerDocDate,
            vehicleColorId, furnitureColorId, madeYear, engineType,
            box, purposeOfUseIds
        } = values;

        pushLoading(true)
        const newOwnerDocDateTmp = newOwnerDocDate ? newOwnerDocDate?.format('YYYY/MM/DD') : undefined
        const oldOwnerDocDateTmp = oldOwnerDocDate ? oldOwnerDocDate?.format('YYYY/MM/DD') : undefined
        const ownershipEndDatetmp = ownershipEndDate ? ownershipEndDate?.format('YYYY/MM/DD') : undefined
        const madeYearTmp = madeYear ? madeYear?.format('YYYY') : undefined

        const result = await editVehicleOwnership(
            infoVehicleOwnership?.id, vehicleStatus, paperReason, vehicleChassisNo,
            idCustomer, newOwnerCustomerId, vehicleId, oldOwnerDocDateTmp,
            ownershipEndDatetmp, newOwnerDocDateTmp, oldVehiclePlateNumber, newVehiclePlateNumber,
            vehicleColorId, furnitureColorId, madeYearTmp, engineType,
            box, purposeOfUseIds

        )
        if (result?.status) {
            resultFormSubmit?.(true, result?.message)
        } else {
            resultFormSubmit?.(false, result?.message)
        }
        pushLoading(false)

    }, 2000)


    //#region Thay đổi form rs 
    useEffect(() => {
        if (!isOpen) return

        gSLChassisNo()
        if (isProgrammaticCarLineSet.current) {
            isProgrammaticCarLineSet.current = false;
            return;
        }
        if (isOpen) {
            form.setFieldValue("vehicleChassisNo", undefined); //rs Số khung (VIN)
        }
    }, [vehicleId]); //tên xe thay đổi

    // #endregion



    useEffect(() => {
        if (isOpen)
            gSLCarId()
    }, [searchCar])


    useEffect(() => {
        if (isOpen)
            gSLPurposeOfUse()
    }, [searchPurposeOfUse])


    useEffect(() => {
        if (!isOpen) return
        if (dropdownRef.current) {
            const scrollContainer =
                dropdownRef.current.querySelector('.rc-virtual-list-holder');

            scrollContainer?.scrollTo({
                top: 0,
                behavior: 'auto',
            });
        }

        if (!sLCodeCustomer.length && !searchUser) {
            gSListCodeCustomer();
            return
        }

        if (searchUser !== prevSearchRef.current) {
            gSListCodeCustomer();
            // cập nhật prevSearchRef sau khi chạy
            prevSearchRef.current = searchUser;

            if (scrollRef.current) {
                scrollRef.current.scrollTo({ top: 0 });
            }
        }
    }, [searchUser])

    useEffect(() => {
        if (isOpen && vehicleStatus === VehicleStatusEnum.IN_USE && infoVehicleOwnership) {
            if (!cLCarColor.length)
                gCLCarColor()

            if (searchPurposeOfUse !== prevSearchRef.current) {
                gSLPurposeOfUse();
                // cập nhật prevSearchRef sau khi chạy
                prevSearchRef.current = searchPurposeOfUse;

                if (scrollRef.current) {
                    scrollRef.current.scrollTo({ top: 0 });
                }
            }

            const { vehicleColorId, furnitureColorId, madeYear, engineType, invoiceSaleBoxName } = infoVehicleOwnership
            const madeYearTmp = madeYear ? dayjs().year(Number(madeYear)) : null

            form.setFieldsValue({
                vehicleColorId: vehicleColorId,
                furnitureColorId: furnitureColorId,
                madeYear: madeYearTmp,
                engineType: engineType,
                box: invoiceSaleBoxName,
            })
        }
    }, [isOpen, vehicleStatus]);


    useEffect(() => {
        if (!sLCodeCustomer.length && vehicleStatus === VehicleStatusEnum.SOLD && isOpen)
            gSListCodeCustomer()
    }, [vehicleStatus, isOpen])

    useEffect(() => {
        if (isOpen) {
            // console.log(isOpen, infoVehicleOwnership);

            if (!sLCarId.length)
                gSLCarId()
            if (infoVehicleOwnership) {
                isProgrammaticCarLineSet.current = true;
                // isProgrammaticPlate.current = true;
                // isProgrammaticChassisNo.current = true;

                const {
                    VehiclePlateNumbers, carName, customerCode, customerId, customerName, id, invoiceSaleDocDate,
                    vehicleChassisNo, vehicleId, vehicleStatus, paperReason, purposeOfUseId, invoiceSaleBoxName
                } = infoVehicleOwnership

                const startDateOwnershipTmp = invoiceSaleDocDate ? handleStringToDayJsV4(invoiceSaleDocDate) : dayjs()
                const customerNameTmp = customerCode && customerName ? `${customerName} (${customerCode}) ` : customerName || customerCode || '';


                form.setFieldsValue({
                    vehicleId: vehicleId,
                    vehicleChassisNo: vehicleChassisNo,
                    customerName: customerNameTmp,
                    oldVehiclePlateNumber: (VehiclePlateNumbers || []).map(x => x.plateNumber).filter(Boolean).join(', ').toUpperCase(),
                    oldOwnerDocDate: startDateOwnershipTmp,
                    ownershipEndDate: dayjs(),
                    vehicleStatus: vehicleStatus,

                    newOwnerDocDate: dayjs().add(1, 'day'),

                    box: invoiceSaleBoxName,
                    paperReason: paperReason,
                    purposeOfUseIds: purposeOfUseId
                });
            } else {
                form.resetFields()
            }
        }

    }, [isOpen, infoVehicleOwnership]);


    return (
        <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            initialValues={{
                isTransfer: false,
            }}
        >
            <ConfigProvider locale={viVN}>
                <Modal
                    title={<div className="bg-FCFCFD d-flex justify-betweeen align-center pb-4  w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                        <span className="text-base text-344054 fw-500 font-medium">Cập nhật thông tin xe</span>
                        <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
                    </div>}
                    open={isOpen}
                    onCancel={() => closeModal(false)}
                    centered
                    className=" custom-modal-ant-history"
                    destroyOnClose
                    closeIcon={false}
                    footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center pt-2  w-full border-t-F0F0F0">
                        <div className="custom-page-css w-full flex justify-end gap-2 mt-4">
                            <Button onClick={() => closeModal(false)}>Huỷ</Button>
                            <Button
                                type="primary"
                                onClick={submitForm}
                            >Lưu</Button>
                        </div>
                    </div>}
                >
                    <div className="custom-modal-ant-history-child custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-2 py-2">
                        {/* Thông tin xe */}
                        <Row gutter={24} className={` custom-page-css pt-2`}>
                            <Col span={8}
                                className={`${getEditClass(permission?.own_vehicle_name?.view, permission?.own_vehicle_name?.edit)} `}
                            >
                                <Form.Item
                                    label={<span>
                                        Tên xe <span className="text-FF1D1D">*</span>
                                    </span>}
                                    name="vehicleId"
                                    layout="vertical"
                                >
                                    <Select
                                        className="custom-page-css border rounded"
                                        placeholder="Tên xe"
                                        showSearch
                                        searchValue={searchCar}
                                        onSearch={(e) => setSearchCar(e)}
                                        filterOption={false}
                                        allowClear
                                        options={sLCarId}
                                        disabled
                                        onChange={(value, option: any) => {
                                            // console.log(option.id)
                                            form.setFieldsValue({
                                                // vehicleId: value,
                                                carId: option.carId
                                            });
                                        }}
                                    />

                                </Form.Item>
                            </Col>
                            <Col span={8}
                              className={`${getEditClass(permission?.own_chassis_no?.view, permission?.own_chassis_no?.edit)} `}
                            >
                                <Form.Item
                                    label={<span>
                                        Số khung <span className="text-FF1D1D">*</span>
                                    </span>}
                                    name="vehicleChassisNo"
                                    layout="vertical"
                                >
                                    <Select
                                        className="custom-page-css border rounded"
                                        placeholder="Số khung"
                                        // disabled={!vehicleId}
                                        options={sLChassisNo}
                                        disabled
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}
                              className={`${getEditClass(permission?.own_vehicle_status?.view, permission?.own_vehicle_status?.edit)} `}
                            >
                                <Form.Item
                                    label={<span>
                                        Tình trạng xe <span className="text-FF1D1D w-full">*</span>
                                    </span>}
                                    name="vehicleStatus"
                                    layout="vertical"
                                >
                                    <Select
                                        className={` custom-page-css border rounded w-full`}
                                        placeholder="Tình trạng xe"
                                        disabled={!vehicleChassisNo}
                                        options={dataVehicleStatus}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        {
                            vehicleStatus === VehicleStatusEnum.IN_USE ? (
                                <>
                                    <Row gutter={24} className={`${getEditClass(permission?.own_number_plate?.view, permission?.own_number_plate?.edit)} custom-page-css pt-2`}>
                                        <Col span={8}>
                                            <Form.Item
                                                label={<span>
                                                    Biển số xe <span className="text-FF1D1D">*</span>
                                                </span>}
                                                name="oldVehiclePlateNumber"
                                                layout="vertical"
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8} className={getEditClass(permission?.own_color_name?.view, permission?.own_color_name?.edit)}>
                                            <Form.Item
                                                label={<span>
                                                    Màu xe
                                                </span>}
                                                name="vehicleColorId"
                                                layout="vertical"
                                            >
                                                <Select
                                                    className="custom-page-css border rounded"
                                                    placeholder="Màu xe"
                                                    options={cLCarColor}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8} className={getEditClass(permission?.own_interior_color?.view, permission?.own_interior_color?.edit)}>
                                            <Form.Item
                                                label={<span>
                                                    Màu nội thất
                                                </span>}
                                                name="furnitureColorId"
                                                layout="vertical"
                                            >
                                                <Select
                                                    className="custom-page-css border rounded w-full"
                                                    placeholder="Màu nội thất"
                                                    options={cLCarColor}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={24}
                                        className={`${getEditClass(permission?.own_made_year?.view, permission?.own_made_year?.edit)} custom-page-css pt-2`}

                                    >
                                        <Col span={8}>
                                            <Form.Item
                                                label={<span>
                                                    Năm Sản xuất
                                                </span>}
                                                name="madeYear"
                                                layout="vertical"
                                            >
                                                <DatePicker
                                                    picker="year"
                                                    className="w-full custom-input-date"
                                                    format="YYYY"
                                                    allowClear={false}
                                                    maxDate={dayjs().add(1, 'year').endOf('year')}
                                                    placeholder="Chọn năm"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}
                                            className={getEditClass(permission?.own_engine_type?.view, permission?.own_engine_type?.edit)}
                                        >
                                            <Form.Item
                                                label={<span>
                                                    Loại động cơ
                                                </span>}
                                                name="engineType"
                                                layout="vertical"
                                            >
                                                <Input
                                                    className="custom-input-css"
                                                    placeholder="Loại động cơ"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}
                                            className={getEditClass(permission?.own_box_code?.view, permission?.own_box_code?.edit)}
                                        >
                                            <Form.Item
                                                label={<span>
                                                    Thùng
                                                </span>}
                                                name="box"
                                                layout="vertical"
                                            >
                                                {/* <Select
                                                    className="custom-page-css border rounded w-full"
                                                    placeholder="Thùng"
                                                    disabled={!vehicleChassisNo}
                                                    options={vehicleStatus}
                                                /> */}
                                                <Input
                                                    className="custom-input-css"
                                                    placeholder="Thùng"
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={24}

                                        className={`${getEditClass(permission?.purpose_of_use?.view, permission?.purpose_of_use?.edit)} custom-page-css pt-2`}

                                    >

                                        <Col span={24}>
                                            <Form.Item
                                                label={<span>
                                                    Mục đích sử dụng:
                                                </span>}
                                                name="purposeOfUseIds"
                                                layout="vertical"
                                            >
                                                <Select
                                                    className="custom-scroll-multi-select custom-page-css border rounded overflow-hidden w-full"
                                                    placeholder="Chọn mục đích sử dụng"
                                                    mode="multiple"
                                                    options={sLPurposeOfUse}
                                                    // onChange={handleChangeTagCustomertype}
                                                    onSearch={(value) => setSearchPurposeOfUse(value)}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </>
                            ) : (
                                <>
                                    {/* Chủ sở hữu */}
                                    <span className="text-base text-344054 fw-500 font-medium" >Chủ sở hữu hiện tại</span>

                                    <Row className="custom-page-css gap-3 flex justify-between items-center nowrap">
                                        <Col span={11}>

                                            <div className="border-1677ff-2px d-flex flex-column gap-2 p-4 rounded-2"  >
                                                <Form.Item
                                                    label="Chủ sở hữu"
                                                    name='customerName'
                                                    layout="vertical"
                                                >
                                                    <Input disabled />
                                                </Form.Item>
                                                <Form.Item
                                                    label={<span>
                                                        Biển số xe <span className="text-FF1D1D">*</span>
                                                    </span>}
                                                    name='oldVehiclePlateNumber'
                                                    layout="vertical"
                                                >
                                                    <Input disabled />
                                                </Form.Item>
                                                <Row gutter={16}>
                                                    <Col span={12}>
                                                        <Form.Item
                                                            label={<span>
                                                                Ngày bắt đầu sở hữu <span className="text-FF1D1D">*</span>
                                                            </span>}
                                                            name='oldOwnerDocDate'
                                                        >
                                                            <DatePicker
                                                                allowClear={false}
                                                                className="w-full"
                                                                format="DD/MM/YYYY"
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={12}>
                                                        <Form.Item
                                                            label={
                                                                <span>
                                                                    Ngày kết thúc sở hữu <span className="text-FF1D1D">*</span>
                                                                </span>
                                                            }
                                                            name="ownershipEndDate"
                                                            dependencies={['oldOwnerDocDate']}
                                                            rules={[
                                                                { required: true, message: 'Vui lòng chọn ngày kết thúc sở hữu' },
                                                                ({ getFieldValue }) => ({
                                                                    validator(_, value) {
                                                                        const startDate = getFieldValue('oldOwnerDocDate')

                                                                        if (!value || !startDate) return Promise.resolve()

                                                                        if (dayjs(value).isBefore(dayjs(startDate), 'day')) {
                                                                            return Promise.reject(
                                                                                new Error('Ngày kết thúc phải lớn hơn hoặc bằng ngày bắt đầu')
                                                                            )
                                                                        }
                                                                        return Promise.resolve()
                                                                    },
                                                                }),
                                                            ]}
                                                        >
                                                            <DatePicker
                                                                className="w-full"
                                                                allowClear={false}
                                                                format="DD/MM/YYYY"
                                                                disabled={!oldOwnerDocDate}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>

                                        <div className="custom-page-css h-full flex  items-center justify-center gap-2">
                                            {/* <Col span={2} style={{ textAlign: "center" }}> */}
                                            <Button type="primary">→</Button>
                                            {/* </Col> */}
                                        </div>


                                        <Col span={11} >

                                            <div className={`${"border-1677ff-2px"} d-flex flex-column gap-2 p-4 rounded-2`}>

                                                <Form.Item
                                                    label={
                                                        <span>
                                                            Chủ sở hữu <span className="text-FF1D1D">*</span>
                                                        </span>
                                                    }
                                                    name='newOwnerCustomerId'
                                                    layout="vertical"
                                                    rules={[
                                                        { required: true, message: "Vui chọn chủ sở hữu!" }
                                                    ]}
                                                >
                                                    <Select
                                                        className="custom-page-css border rounded"
                                                        placeholder="Chọn chủ sở hữu"
                                                        showSearch
                                                        searchValue={searchUser}
                                                        onSearch={(e) => setSearchUser(e)}
                                                        filterOption={false}
                                                        allowClear
                                                        options={sLCodeCustomer.map((item) => ({
                                                            value: item.id,         // Giá trị hiển thị trong ô tìm kiếm
                                                            label: `${item.code} - ${item.username}`, // Gợi ý hiển thị dropdown
                                                            id: item.id,              // Giá trị thực tế bạn muốn lấy khi chọn
                                                            phone: item.phone,          // Thêm thông tin khác nếu cần
                                                        }))}

                                                        // ref={(el) => {
                                                        //     scrollRef.current = el;
                                                        // }}
                                                        // onScroll={(e) => onPopupScroll?.(e)}

                                                        onPopupScroll={onPopupScroll}
                                                        dropdownRender={(menu) => (
                                                            <div
                                                                ref={(node) => {
                                                                    dropdownRef.current = node;
                                                                }}
                                                            >
                                                                {menu}
                                                            </div>
                                                        )}
                                                    // onChange={(value, option: any) => {
                                                    //     // console.log(option.id)
                                                    //     form.setFieldsValue({
                                                    //         // vehicleId: value,
                                                    //         newOwnerCustomerId: option.id
                                                    //     });
                                                    // }}
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Biển số xe mới"
                                                    name='newVehiclePlateNumber'
                                                    layout="vertical"
                                                >
                                                    <Input
                                                        className="custom-input-css"
                                                        placeholder="Biển số xe mới"
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    label={
                                                        <span>
                                                            Ngày bắt đầu sở hữu <span className="text-FF1D1D">*</span>
                                                        </span>
                                                    }
                                                    name='newOwnerDocDate'
                                                    layout="vertical"
                                                    dependencies={['ownershipEndDate']}
                                                    rules={[
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {

                                                                const endDate = getFieldValue('ownershipEndDate')
                                                                if (!value || !endDate) {
                                                                    return Promise.resolve()
                                                                }

                                                                if (dayjs(value).isAfter(dayjs(endDate), 'day')) {
                                                                    return Promise.resolve()
                                                                }

                                                                return Promise.reject(
                                                                    new Error('Ngày bắt đầu sở hữu mới phải lớn hơn ngày kết thúc ít nhất 1 ngày')
                                                                )
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <DatePicker
                                                        className="w-full"
                                                        allowClear={false}
                                                        format="DD/MM/YYYY"
                                                    />
                                                </Form.Item>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )
                        }





                        {/* Lý do */}
                        <Form.Item
                            // label="Lý do cập nhật"
                             className={`${getEditClass(permission?.paper_reason?.view, permission?.paper_reason?.edit)} `}
                            label={
                                <span>
                                    Lý do cập nhật <span className="text-FF1D1D">*</span>
                                </span>
                            }
                            name='paperReason'
                            layout="vertical"
                            rules={[
                                { required: true, message: "Vui lòng nhập lý do cập nhật" }
                            ]}
                        >
                            <TextArea className="custom-input-css" rows={4} placeholder="Nhập lý do cập nhật" />
                        </Form.Item>



                    </div>
                </Modal>
            </ConfigProvider>
        </Form>
    )
}
export default ModalUpdateVehicleInformation
